import { render, staticRenderFns } from "./BestPracticesReport.vue?vue&type=template&id=50eb3f87"
import script from "./BestPracticesReport.vue?vue&type=script&lang=js"
export * from "./BestPracticesReport.vue?vue&type=script&lang=js"
import style0 from "./BestPracticesReport.vue?vue&type=style&index=0&id=50eb3f87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports